var _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnModu18 = function SvgLightIcnModu18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "light_icn_modu_18_svg__a",
    width: 24,
    height: 16,
    x: 1,
    y: 5,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1 5.592h24v14.562H1z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#light_icn_modu_18_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0078FF",
    fillRule: "evenodd",
    d: "m20.819 10.407-.005-.028a4.2 4.2 0 0 1-4.665 2.915v-2.49h.65a1.661 1.661 0 1 0 0-3.321V7.48h-1.663v9.378c0 .586-.344.832-.887.832H12.6V5.592a6.25 6.25 0 0 0-3.49 3.097 3.868 3.868 0 0 0-4.731 3.095 4.228 4.228 0 0 0 .824 8.37h14.953a4.9 4.9 0 0 0 .664-9.747",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078FF",
    fillRule: "evenodd",
    d: "M16.542 3.594c-.49 0-.81.015-.924.021h-.01a.712.712 0 0 0 .088 1.42h.01c.079-.004.372-.019.835-.019 2.473 0 4.221 1.57 4.35 3.906a.71.71 0 0 0 .71.672l.04-.001a.71.71 0 0 0 .671-.75c-.171-3.09-2.544-5.25-5.77-5.25",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078FF",
    fillRule: "evenodd",
    d: "M24.859 7.656C24.172 3.676 20.813 1 16.5 1q-.48 0-.898.012a.713.713 0 0 0-.69.733c.011.386.323.69.71.69h.021q.4-.013.857-.013c1.772 0 3.368.515 4.615 1.49 1.25.978 2.06 2.356 2.341 3.986a.71.71 0 1 0 1.402-.242",
    clipRule: "evenodd"
  })));
};
export default SvgLightIcnModu18;